import React, { useState, useEffect } from 'react';
import Styles from './CDCProtegido25Condicoes.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import ModalSeguros from '@/components/molecules/ModalSeguros';

function CDCProtegido25Condicoes() {
  const [showModal, setShowModal] = useState(false);
  const tituloModal = 'Condições contratuais';
  const docs = [
    {
      titulo: 'Condições Contratuais: CDC Protegido',
      descricao: `Vigência: de 01/02/2022 até 31/06/2023`,
      link: 'pdf/protegido/15414.901791_2019-11 CGs_NV_Prestamista v4.pdf',
    },
    {
      titulo: 'Condições Contratuais: CDC Protegido',
      descricao: `Vigência: de 20/01/2021 até 31/01/2022`,
      link: 'pdf/protegido/15414.901791_2019-11 CGs_NV_Prestamista v4.pdf',
    },
    {
      titulo: 'Condições Contratuais: CDC Protegido',
      descricao: `Vigência: de 23/09/2020 até 19/01/2021`,
      link: 'pdf/protegido/15414.901791_2019-11 CGs_NV_Prestamista v3.pdf',
    },
    {
      titulo: 'Condições Contratuais: CDC Protegido',
      descricao: `Vigência: de 27/06/2020 até 22/09/2020`,
      link: 'pdf/protegido/15414.901791_2019-11 CGs_NV_Prestamista_v2.pdf',
    },
    {
      titulo: 'Condições Contratuais: CDC Protegido',
      descricao: `Vigência: de 30/09/2019 até 26/06/2020`,
      link: 'pdf/protegido/CGs_NV_Prestamista_v1.pdf',
    },
    {
      titulo: 'Condições Contratuais: CDC Protegido',
      descricao: `Vigência: até 29/09/2019 `,
      link: 'pdf/protegido/CG-Prestamista-CDC-Protegido-Out19.pdf',
    },
  ];

  useEffect(() => {
    if (showModal) {
      document.getElementsByTagName('html')[0].classList.add('scroll-disabled');
    } else {
      document.getElementsByTagName('html')[0].classList.remove('scroll-disabled');
    }
  }, [showModal]);
  return (
    <>
      <section id="seguro-auto-condicoes">
        <ContainerHome24>
          <div className="condicoes-contain">
            <img src="assets/seguro-auto-25/carros.svg" alt="" className="condicoes-contain-img" />
            <div className="condicoes-contain-conteudo">
              <h2 className="condicoes-contain-titulo">Conheça nossas condições contratuais</h2>
              <div className="tab-santander-auto-condicoes active">
                <div className="cards-condicao">
                  <a
                    href="pdf/protegido/Condicoes_Gerais_Prestamista_PJ.pdf"
                    target="_blank"
                    className="card-condicao"
                  >
                    <img src="assets/seguro-auto-25/ic_file_pdf.svg" alt="" />
                    <div className="condicao-textos">
                      <h3 className="condicao-textos-titulo">
                        Condições Gerais Seguro Proteção PJ
                      </h3>
                      <p className="condicao-textos-descricao">
                        Versão 4 - PROCESSO SUSEP NO 15414.902051/2019-00
                      </p>
                    </div>
                  </a>
                  <a
                    href="pdf/protegido/condicoes-gerais-do-seguro-AP-v3.pdf"
                    target="_blank"
                    className="card-condicao"
                  >
                    <img src="assets/seguro-auto-25/ic_file_pdf.svg" alt="" />
                    <div className="condicao-textos">
                      <h3 className="condicao-textos-titulo">Condições Gerais do Seguro AP</h3>
                      <p className="condicao-textos-descricao">
                        Versão V01_052019 - PROCESSO SUSEP NO 15414.901986.2019-61
                      </p>
                    </div>
                  </a>
                  <a
                    href="pdf/protegido/Condicoes_Gerais_Prestamista_082026.pdf"
                    target="_blank"
                    className="card-condicao"
                  >
                    <img src="assets/seguro-auto-25/ic_file_pdf.svg" alt="" />
                    <div className="condicao-textos">
                      <h3 className="condicao-textos-titulo">
                        Condições Contratuais: CDC Protegido
                      </h3>
                      <p className="condicao-textos-descricao">Vigência: de 01/08/2026 em diante</p>
                    </div>
                  </a>
                  <a
                    href="pdf/protegido/Condicoes-Gerais-Prestamista-versao-site.pdf"
                    target="_blank"
                    className="card-condicao"
                  >
                    <img src="assets/seguro-auto-25/ic_file_pdf.svg" alt="" />
                    <div className="condicao-textos">
                      <h3 className="condicao-textos-titulo">
                        Condições Contratuais: CDC Protegido
                      </h3>
                      <p className="condicao-textos-descricao">
                        Vigência: de 01/07/2023 até 31/07/2026
                      </p>
                    </div>
                  </a>
                </div>
                <div
                  onClick={(e) => {
                    e.preventDefault();
                    setShowModal(true);
                  }}
                  className="link-condicoes-antigas"
                >
                  Exibir condições mais antigas
                </div>
              </div>
            </div>
          </div>
        </ContainerHome24>
      </section>
      {showModal && (
        <ModalSeguros setShowModal={setShowModal} tituloModal={tituloModal} docs={docs} />
      )}
      <style jsx>{Styles}</style>
    </>
  );
}

export default CDCProtegido25Condicoes;
